export const delta = (x, y) => {
  return x - y;
}